import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

function getInitialUser() {
  if (typeof window === "undefined") return null;
  const saved = window.localStorage.getItem("tt-user");
  return saved ? JSON.parse(saved) : null;
}

function getInitialToken() {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem("tt-token");
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getInitialUser);
  const [token, setToken] = useState(getInitialToken);

  useEffect(() => {
    if (user) window.localStorage.setItem("tt-user", JSON.stringify(user));
    else window.localStorage.removeItem("tt-user");
  }, [user]);

  useEffect(() => {
    if (token) window.localStorage.setItem("tt-token", token);
    else window.localStorage.removeItem("tt-token");
  }, [token]);

  function login(userData, authToken) {
    setUser(userData);
    setToken(authToken);
  }

  function logout() {
    setUser(null);
    setToken(null);
  }

  // Merge a partial user update (e.g. after editing the profile) into the
  // signed-in user without needing a fresh login.
  function updateUser(partialUser) {
    setUser((prev) => (prev ? { ...prev, ...partialUser } : partialUser));
  }

  return (
    <AuthContext.Provider value={{ user, token, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within an AuthProvider");
  return ctx;
}
